import { API_VERSION, HOME_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_HOMES = `${HOME_SERVICE}/price-levels`;

export const priceLevel = {
  getAll: async ({ filters, sort, params, signal, top, skip } = {}) => {
    const options = await apiOptions({
      url: `${API_HOMES}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      signal,
      params,
      filters,
      sort,
      top,
      skip,
    });
    return apiRequest(options);
  },
  getById: async ({ id } = {}) => {
    const options = await apiOptions({
      url: `${API_HOMES}/${id}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },
  create: async ({ data, toastMessageConfig } = {}) => {
    const options = await apiOptions({
      url: `${API_HOMES}`,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  update: async ({ data, toastMessageConfig } = {}) => {
    const options = await apiOptions({
      url: `${API_HOMES}/${data.id}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  reorder: async ({ data, toastMessageConfig } = {}) => {
    const options = await apiOptions({
      url: `${API_HOMES}/reorder`,
      method: "put",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  duplicate: async ({ id, toastMessageConfig } = {}) => {
    const options = await apiOptions({
      url: `${API_HOMES}/${id}/duplicate`,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options, toastMessageConfig);
  },
  delete: async ({ data, toastMessageConfig } = {}) => {
    const options = await apiOptions({
      url: `${API_HOMES}/${data.id}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  getDeleteOptions: async ({ data } = {}) =>
    apiOptions({
      url: `${API_HOMES}/${data.id}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    }),
  getActivities: async () => {
    const options = await apiOptions({
      url: `${API_HOMES}/activities`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },
  account: {
    create: async ({ data, toastMessageConfig } = {}) => {
      const options = await apiOptions({
        url: `${API_HOMES}/account`,
        method: "put",
        headers: { [X_API_VERSION]: API_VERSION },
        data,
      });
      return apiRequest(options, toastMessageConfig);
    },
  },
};
